<template>

</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
  name: 'Author',
  data () {
    return {
      appId: 'wx8de3b9a5bbf2ccdf',
      redirecUrl: null
    }
  },
  beforeRouteEnter (to, from, next) {
    next(async vm => {
      // 通过 `vm` 访问组件实例
      let code = vm.getCode
      if (code) {
        let json = await axios.get(`http://shengyi-helper.i200.cn/oauth2/basecallback?code=${code}`)
        if (json.openId) {
          vm.$store.commit('setOpenId', json.openId)
          vm.$router.push({ path: '/register' })
        }
      } else {
        vm.redirecUrl = `http://${window.location.host}/#${to.fullPath}`
        vm.redirectWX()
      }
    })
  },
  methods: {
    redirectWX () {
      let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + this.appId +
        '&redirect_uri=' + encodeURIComponent(this.redirecUrl) +
        '&response_type=code&scope=snsapi_base&state=#wechat_redirect'
      window.location.replace(url)
    }
  },
  computed: {
    ...mapGetters([
      'getCode'
    ])
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Author.vue?7414441b